import React, {
  useEffect,
  useState,
} from "react";
import logo from "../assets/logo.png";
import {
  useParams,
  useNavigate,
} from "react-router-dom";

import axios from "axios";

import {
  ShieldCheck,
  FileText,
  Car,
  BadgeDollarSign,
  CalendarClock,
  Pencil,
  Trash2,
  Plus,
  Save,
  UploadCloud,
} from "lucide-react";

import {
  toast,
} from "react-toastify";

import RenewalModal from "../components/RenewalModal";

import "../styles/clientAccount.css";

const API_BASE =
  "https://client-management-backend-8x91.onrender.com";

const InsuranceClientAccount = () => {

  const { clientId } =
    useParams();

  const navigate =
    useNavigate();

  /* =====================================
      STATES
  ===================================== */

  const [client,
    setClient,
  ] = useState(null);

  const [renewals,
    setRenewals,
  ] = useState([]);

  const [attachments,
    setAttachments,
  ] = useState([]);

  const [loading,
    setLoading,
  ] = useState(true);

  const [uploading,
    setUploading,
  ] = useState(false);

  const [isEditing,
    setIsEditing,
  ] = useState(false);

  const [
    isRenewalModalOpen,
    setIsRenewalModalOpen,
  ] = useState(false);

  const [
    attachmentDescription,
    setAttachmentDescription,
  ] = useState("");

const [
  updatedClient,
  setUpdatedClient,
] = useState({

  name: "",
  insurer: "",
  policy_number: "",
  vehicle_number: "",
  premium: "",
  policy_type: "",
  notes: "",

  renewal_date: "",


  premium_paid: "No",
  paid_to_apex: "No",

});

  /* =====================================
      FETCH CLIENT
  ===================================== */

  const fetchClient =
    async () => {

      try {

        const res =
          await axios.get(
            `${API_BASE}/clients/${clientId}`
          );

        setClient(
          res.data
        );

        setUpdatedClient({

          name:
            res.data.name || "",

          insurer:
            res.data.insurer || "",

          policy_number:
            res.data.policy_number || "",

          vehicle_number:
            res.data.vehicle_number || "",

          premium:
            res.data.premium || "",

          policy_type:
            res.data.policy_type || "",
            renewal_date:
  res.data.renewal_date || "",

          notes:
            res.data.notes || "",

            premium_paid:
  res.data.premium_paid || "No",

paid_to_apex:
  res.data.paid_to_apex || "No",

        });

      } catch (err) {

        console.error(err);

        toast.error(
          "Failed to fetch client."
        );

      }

    };

  /* =====================================
      FETCH RENEWALS
  ===================================== */

  const fetchRenewals =
    async () => {

      try {

        const res =
          await axios.get(
            `${API_BASE}/clients/${clientId}/renewals`
          );

        setRenewals(
          res.data || []
        );

      } catch (err) {

        console.error(err);

      }

    };

  /* =====================================
      FETCH ATTACHMENTS
  ===================================== */

  const fetchAttachments =
    async () => {

      try {
const res = await axios.get(
  `${API_BASE}/clients/${clientId}`
);

setAttachments(
  res.data.additional_attachments || []
);

      } catch (err) {

        console.error(err);

      }

    };

  /* =====================================
      INITIAL LOAD
  ===================================== */

  useEffect(() => {

    const loadData =
      async () => {

        setLoading(true);

        await Promise.all([

          fetchClient(),
          fetchRenewals(),
          fetchAttachments(),

        ]);

        setLoading(false);

      };

    loadData();

  }, [clientId]);

  /* =====================================
      EDIT CHANGE
  ===================================== */

  const handleEditChange =
    (e) => {

      setUpdatedClient({

        ...updatedClient,

        [e.target.name]:
          e.target.value,

      });

    };

  /* =====================================
      SAVE CHANGES
  ===================================== */

  const handleSaveChanges =
    async () => {

      try {

        await axios.put(
          `${API_BASE}/clients/${clientId}`,
          updatedClient
        );

        toast.success(
          "Client updated successfully."
        );

        setIsEditing(false);

        fetchClient();

      } catch (err) {

        console.error(err);

        toast.error(
          "Failed to save changes."
        );

      }

    };

  /* =====================================
      DELETE CLIENT
  ===================================== */

  const handleDeleteClient =
    async () => {

      const confirmDelete =
        window.confirm(
          "Delete this client?"
        );

      if (!confirmDelete)
        return;

      try {

        await axios.delete(
          `${API_BASE}/clients/${clientId}`
        );

        toast.success(
          "Client deleted."
        );

        navigate("/insurance");

      } catch (err) {

        console.error(err);

        toast.error(
          "Delete failed."
        );

      }

    };

  /* =====================================
      SAVE RENEWAL
  ===================================== */

  const handleSaveRenewal =
    async (
      renewalData
    ) => {

      try {

        await axios.post(
          `${API_BASE}/clients/${clientId}/renewals`,
          renewalData
        );

        toast.success(
          "Renewal added."
        );

        setIsRenewalModalOpen(
          false
        );

        fetchRenewals();

      } catch (err) {

        console.error(err);

        toast.error(
          "Failed to add renewal."
        );

      }

    };

  /* =====================================
      DELETE RENEWAL
  ===================================== */

  const handleDeleteRenewal =
    async (
      renewalId
    ) => {

      const confirmDelete =
        window.confirm(
          "Delete renewal?"
        );

      if (!confirmDelete)
        return;

      try {

        await axios.delete(
          `${API_BASE}/renewals/${renewalId}`
        );

        toast.success(
          "Renewal deleted."
        );

        fetchRenewals();

      } catch (err) {

        console.error(err);

      }

    };

  /* =====================================
      UPLOAD ATTACHMENT
  ===================================== */

  const handleAttachmentUpload =
    async (e) => {

      const file =
        e.target.files[0];

      if (!file)
        return;

      try {

        setUploading(true);

        const formData =
          new FormData();

        formData.append(
          "file",
          file
        );

        formData.append(
          "description",
          attachmentDescription
        );

await axios.post(
  `${API_BASE}/clients/${clientId}/add-document`,
  formData,
  {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  }
);
        toast.success(
          "Attachment uploaded."
        );

        setAttachmentDescription(
          ""
        );

        fetchAttachments();

      } catch (err) {

        console.error(err);

        toast.error(
          "Upload failed."
        );

      } finally {

        setUploading(false);

      }

    };

  /* =====================================
      DELETE ATTACHMENT
  ===================================== */

const handleDeleteAttachment =
  async (
    attachmentUrl
  ) => {

      try {

await axios.delete(
  `${API_BASE}/clients/${clientId}/document`,
  {
    data: {
      url: attachmentUrl,
    },
  }
);
        toast.success(
          "Attachment deleted."
        );

        fetchAttachments();

      } catch (err) {

        console.error(err);

      }

    };

  /* =====================================
      LOADING
  ===================================== */

if (loading || !client) {

  return (

    <div className="insurance-client-loading-screen">

      <div className="insurance-client-modern-loader">

        <div className="insurance-client-loader-ring" />

        <div className="insurance-client-loader-ring-two" />

        <div className="insurance-client-loader-center">

          <img
            src={logo}
            alt="RCS Logo"
          />

        </div>

      </div>

      <h2>
        Loading Client Profile
      </h2>

      <p>

        Preparing policy records,
        renewals, documents and
        insurance activity...

      </p>

    </div>

  );

}

  
  /* =====================================
      MAIN RETURN
  ===================================== */

  return (

    <div className="insurance-client-command-center">

      {/* HERO */}

      <div className="insurance-client-hero">

        <div className="insurance-client-hero-left">

          <div className="insurance-client-badge">

            <ShieldCheck size={15} />

             CLIENT PROFILE

          </div>

<div className="insurance-client-title-wrap">

  <h1>
    {client.name}
  </h1>

  <div className="insurance-client-id-badge">

    CLIENT ID:
    {" "}
    #{client.id}

  </div>

</div>

          <p>

            {client.insurer}
            {" • "}
            Policy #
            {client.policy_number}

          </p>

          <div className="insurance-client-status-row">



            <div
              className={`insurance-client-status-pill
              ${
                client.premium_paid ===
                "Yes"
                  ? "paid"
                  : "unpaid"
              }`}
            >

              {
                client.premium_paid ===
                "Yes"
                  ? "PREMIUM PAID"
                  : "PREMIUM OUTSTANDING"
              }

            </div>

            <div
              className={`insurance-client-status-pill
              ${
                client.paid_to_apex ===
                "Yes"
                  ? "paid"
                  : "pending"
              }`}
            >

              {
                client.paid_to_apex ===
                "Yes"
                  ? "PAID TO APEX"
                  : "PENDING APEX"
              }

            </div>
<div className="insurance-client-status-pill renewal">

  {isEditing ? (

    <input
      type="date"
      name="renewal_date"
      value={updatedClient.renewal_date || ""}
      onChange={handleEditChange}
      className="insurance-client-renewal-input"
    />

  ) : (

    <>
      NEXT RENEWAL:
      {" "}

      {client.renewal_date
        ? new Date(
            client.renewal_date
          ).toLocaleDateString()
        : "N/A"}
    </>

  )}

</div>

          </div>

        </div>

        {/* ACTIONS */}

        <div className="insurance-client-hero-actions">

          {isEditing ? (

            <button
              className="insurance-client-save-btn"
              onClick={
                handleSaveChanges
              }
            >

              <Save size={18} />

              Save

            </button>

          ) : (

            <button
              className="insurance-client-edit-btn"
              onClick={() =>
                setIsEditing(true)
              }
            >

              <Pencil size={18} />

              Edit

            </button>

          )}

          <button
            className="insurance-client-renew-btn"
            onClick={() =>
              setIsRenewalModalOpen(true)
            }
          >

            <Plus size={18} />

            Renewal

          </button>

          <button
            className="insurance-client-delete-btn"
            onClick={
              handleDeleteClient
            }
          >

            <Trash2 size={18} />

            Delete

          </button>

        </div>

      </div>

      {/* MAIN GRID */}

      <div className="insurance-client-main-grid">

        {/* LEFT */}

        <div className="insurance-client-left-column">

          {/* DETAILS */}

          <div className="insurance-client-card">

            <div className="insurance-client-card-header">

              <h2>
                Policy Details
              </h2>

            </div>

<div className="insurance-client-details-grid">

  {/* CLIENT */}

  <div className="insurance-client-detail-card">

    <div className="insurance-client-detail-icon">

      <ShieldCheck size={18} />

    </div>

    <div className="insurance-client-detail-content">

      <span>
        Client Name
      </span>

      {isEditing ? (

        <input
          type="text"
          name="name"
          value={updatedClient.name}
          onChange={handleEditChange}
        />

      ) : (

        <h4>
          {client.name}
        </h4>

      )}

    </div>

  </div>

  {/* POLICY */}

  <div className="insurance-client-detail-card">

    <div className="insurance-client-detail-icon">

      <FileText size={18} />

    </div>

    <div className="insurance-client-detail-content">

      <span>
        Policy Number
      </span>

      {isEditing ? (

        <input
          type="text"
          name="policy_number"
          value={updatedClient.policy_number}
          onChange={handleEditChange}
        />

      ) : (

        <h4>
          {client.policy_number}
        </h4>

      )}

    </div>

  </div>

  {/* VEHICLE */}

  <div className="insurance-client-detail-card">

    <div className="insurance-client-detail-icon">

      <Car size={18} />

    </div>

    <div className="insurance-client-detail-content">

      <span>
        Vehicle Number
      </span>

      {isEditing ? (

        <input
          type="text"
          name="vehicle_number"
          value={updatedClient.vehicle_number}
          onChange={handleEditChange}
        />

      ) : (

        <h4>
          {client.vehicle_number}
        </h4>

      )}

    </div>

  </div>

  {/* PREMIUM */}

  <div className="insurance-client-detail-card">

    <div className="insurance-client-detail-icon">

      <BadgeDollarSign size={18} />

    </div>

    <div className="insurance-client-detail-content">

      <span>
        Premium
      </span>

      {isEditing ? (

        <input
          type="text"
          name="premium"
          value={updatedClient.premium}
          onChange={handleEditChange}
        />

      ) : (

        <h4>
          ${client.premium}
        </h4>

      )}

    </div>

  </div>


{/* PAYMENT NUMBER */}

<div className="insurance-client-detail-card">

  <div className="insurance-client-detail-icon">

    <BadgeDollarSign size={18} />

  </div>

  <div className="insurance-client-detail-content">

    <span>
      Payment Number
    </span>

    {isEditing ? (

      <input
        type="text"
        name="payment_number"
        value={updatedClient.payment_number}
        onChange={handleEditChange}
      />

    ) : (

      <h4>
        {client.payment_number || "N/A"}
      </h4>

    )}

  </div>

</div>


{/* POLICY STATUS */}

<div className="insurance-client-detail-card">

  <div className="insurance-client-detail-icon">

    <ShieldCheck size={18} />

  </div>

  <div className="insurance-client-detail-content">

    <span>
      Policy Status
    </span>

    <h4
      className={
        new Date(client.renewal_date) < new Date()
          ? "insurance-policy-expired"
          : "insurance-policy-active"
      }
    >

      {new Date(client.renewal_date) < new Date()
        ? "Expired"
        : "Active"}

    </h4>

  </div>

</div>

<div className="insurance-client-trigger-row">

  {/* PREMIUM */}

  <div
    className={`insurance-client-trigger-card-small ${
      updatedClient.premium_paid === "Yes"
        ? "active"
        : "inactive"
    }`}
  >

    <div className="insurance-client-trigger-header">

      <span>
        PREMIUM PAID
      </span>

      <div
        className={`insurance-client-trigger-dot ${
          updatedClient.premium_paid === "Yes"
            ? "on"
            : "off"
        }`}
      />

    </div>

    <h4>
      {updatedClient.premium_paid === "Yes"
        ? "PAID"
        : "UNPAID"}
    </h4>

    {isEditing && (

      <button
        type="button"
        className="insurance-client-trigger-toggle"
        onClick={() =>
          setUpdatedClient({
            ...updatedClient,
            premium_paid:
              updatedClient.premium_paid === "Yes"
                ? "No"
                : "Yes",
          })
        }
      >

        Toggle

      </button>

    )}

  </div>

  {/* APEX */}

  <div
    className={`insurance-client-trigger-card-small ${
      updatedClient.paid_to_apex === "Yes"
        ? "active"
        : "inactive"
    }`}
  >

    <div className="insurance-client-trigger-header">

      <span>
        PAID TO APEX
      </span>

      <div
        className={`insurance-client-trigger-dot ${
          updatedClient.paid_to_apex === "Yes"
            ? "on"
            : "off"
        }`}
      />

    </div>

    <h4>
      {updatedClient.paid_to_apex === "Yes"
        ? "CONFIRMED"
        : "PENDING"}
    </h4>

    {isEditing && (

      <button
        type="button"
        className="insurance-client-trigger-toggle"
        onClick={() =>
          setUpdatedClient({
            ...updatedClient,
            paid_to_apex:
              updatedClient.paid_to_apex === "Yes"
                ? "No"
                : "Yes",
          })
        }
      >

        Toggle

      </button>

    )}

  </div>

</div>


  {/* INSURER */}

  <div className="insurance-client-detail-card">

    <div className="insurance-client-detail-icon">

      <ShieldCheck size={18} />

    </div>

    <div className="insurance-client-detail-content">

      <span>
        Insurer
      </span>

      {isEditing ? (

        <input
          type="text"
          name="insurer"
          value={updatedClient.insurer}
          onChange={handleEditChange}
        />

      ) : (

        <h4>
          {client.insurer}
        </h4>

      )}

    </div>

  </div>

  {/* POLICY TYPE */}

  <div className="insurance-client-detail-card">

    <div className="insurance-client-detail-icon">

      <CalendarClock size={18} />

    </div>

    <div className="insurance-client-detail-content">

      <span>
        Policy Type
      </span>

      {isEditing ? (

        <select
          name="policy_type"
          value={updatedClient.policy_type}
          onChange={handleEditChange}
        >

          <option value="Motor">
            Motor
          </option>

          <option value="Fire">
            Fire
          </option>

          <option value="Life">
            Life
          </option>

        </select>

      ) : (

        <h4>
          {client.policy_type}
        </h4>

      )}

    </div>

  </div>

</div>
</div>
          {/* NOTES */}

          <div className="insurance-client-card">

            <div className="insurance-client-card-header">

              <h2>
                Internal Notes
              </h2>

            </div>

            {isEditing ? (

              <textarea
                name="notes"
                value={
                  updatedClient.notes
                }
                onChange={
                  handleEditChange
                }
                className="insurance-client-notes-input"
              />

            ) : (

              <div className="insurance-client-notes-display">

                {
                  client.notes ||
                  "No notes added."
                }

              </div>

            )}

          </div>

          {/* TIMELINE */}

          <div className="insurance-client-card">

            <div className="insurance-client-card-header">

              <h2>
                Renewal Timeline
              </h2>

            </div>

            {renewals.length > 0 ? (

              <div className="insurance-client-timeline">

                {renewals.map(
                  (
                    renewal,
                    index
                  ) => (

                    <div
                      key={
                        renewal.id ||
                        index
                      }
                      className="insurance-client-timeline-item"
                    >

                      <div className="insurance-client-timeline-dot" />

                      <div className="insurance-client-timeline-content">

                        <h4>

                          Renewal:
                          {" "}
                          {new Date(
                            renewal.renewal_date
                          ).toLocaleDateString()}

                        </h4>

                        <p>

                          Next Renewal:
                          {" "}
                          {new Date(
                            renewal.next_renewal_date
                          ).toLocaleDateString()}

                        </p>

                        <div className="insurance-client-timeline-actions">

                          <a
                            href={
                              renewal.policy_document
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                            className="timeline-doc-btn"
                          >

                            View Policy

                          </a>

                          <button
                            className="timeline-delete-btn"
                            onClick={() =>
                              handleDeleteRenewal(
                                renewal.id
                              )
                            }
                          >

                            Delete

                          </button>

                        </div>

                      </div>

                    </div>

                  )
                )}

              </div>

            ) : (

              <p className="insurance-empty-text">

                No renewals available.

              </p>

            )}

          </div>

        </div>

        {/* RIGHT */}

        <div className="insurance-client-right-column">

          {/* DOCUMENT */}

          <div className="insurance-client-card">

            <div className="insurance-client-card-header">

              <h2>
                Policy Document
              </h2>

            </div>

            {client.policy_document ? (

              <a
                href={
                  client.policy_document
                }
                target="_blank"
                rel="noopener noreferrer"
                className="insurance-client-main-document"
              >

                <FileText size={18} />

                View Policy Document

              </a>

            ) : (

              <p className="insurance-empty-text">

                No policy document uploaded.

              </p>

            )}

          </div>

          {/* ATTACHMENTS */}

          <div className="insurance-client-card">

            <div className="insurance-client-card-header">

              <h2>
                Attachments
              </h2>

            </div>

            <input
              type="text"
              placeholder="Attachment description..."
              value={
                attachmentDescription
              }
              onChange={(e) =>
                setAttachmentDescription(
                  e.target.value
                )
              }
              className="insurance-client-description-input"
            />

            <label className="insurance-client-upload-btn">

              <UploadCloud size={18} />

              {
                uploading
                  ? "Uploading..."
                  : "Upload Attachment"
              }

              <input
                type="file"
                hidden
                onChange={
                  handleAttachmentUpload
                }
              />

            </label>

            <div className="insurance-client-attachments-list">

              {attachments.length ===
              0 ? (

                <p className="insurance-empty-text">

                  No attachments uploaded.

                </p>

              ) : (

                attachments.map(
                  (
                    att,
                    idx
                  ) => (

                    <div
                      key={idx}
                      className="insurance-client-attachment-card"
                    >

                      <div>

                        <h4>

                          {
                            att.description ||
                            "Attachment"
                          }

                        </h4>

                        <span>

                          {new Date(
                            att.created_at
                          ).toLocaleDateString()}

                        </span>

                      </div>

                      <div className="insurance-client-attachment-actions">

                        <a
href={att.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="insurance-client-view-btn"
                        >

                          View

                        </a>

                        <button
                          className="insurance-client-delete-attachment-btn"
                          onClick={() =>
handleDeleteAttachment(att.url)
                          }
                        >

                          Delete

                        </button>

                      </div>

                    </div>

                  )
                )

              )}

            </div>

          </div>

        </div>

      </div>

      {/* RENEWAL MODAL */}

      <RenewalModal
        isOpen={
          isRenewalModalOpen
        }
        onClose={() =>
          setIsRenewalModalOpen(
            false
          )
        }
        onSave={
          handleSaveRenewal
        }
        clientId={clientId}
      />

    </div>

  );

};

export default InsuranceClientAccount;